import React, { useState } from 'react';
import Typography from '../../components/Typography';
import Button from '../../components/Button';
import DatePicker from '../../components/DatePicker';
import { CalendarBlank } from '@phosphor-icons/react';
import moment from 'moment';
import COLORS from '../../util/constants/colors';

const DateRange = ({
  dateRange,
  setDateRange,
}) => {
  const [dateError, setDateError] = useState(null);
  const dateFormat = 'YYYY-MM-DD';
  const DATE_ERROR = '* Start date must be before end date';

  const handleStartDateChange = (date) => {
    setDateError(null);
    const formattedDate = date && date.format ? date.format(dateFormat) : null;
    setDateRange({ ...dateRange, startDate: formattedDate });
    if (formattedDate > dateRange.endDate) {
      setDateError(DATE_ERROR);
    }
  };

  const handleEndDateChange = (date) => {
    setDateError(null);
    const formattedDate = date && date.format ? date.format(dateFormat) : null;
    setDateRange({ ...dateRange, endDate: formattedDate });
    if (formattedDate < dateRange.startDate) {
      setDateError(DATE_ERROR);
    }
  };

  return (
    <div className="date-range">
      <div className="title">
        <Typography variant="text" size="small" bold>
          <CalendarBlank size={16} color={COLORS.BLUE_PRIMARY_LITE}/>
          &nbsp;
          Date Range
        </Typography>
      </div>
      <div className="date-range-pickers">
        <DatePicker
          defaultValue={moment(dateRange.startDate, dateFormat)}
          onChange={handleStartDateChange}
          format={dateFormat}
          value={dateRange.startDate ? moment(dateRange.startDate, dateFormat) : null}
          name="Start Date"
          disabledDate={(current) => {
            // Disable dates beyond today
            if (current && current > moment()) {
              return true;
            }

            // If an end date is selected, enforce constraints
            if (dateRange.endDate && moment(dateRange.endDate).isValid()) {
              const end = moment(dateRange.endDate, dateFormat);
              // Disable dates after the end date
              if (current && current > end) {
                return true;
              }
              // Disable dates more than 3 months before the end date
              if (current && current < end.clone().subtract(3, 'months')) {
                return true;
              }
            }

            return false;
          }}
        />
        <Typography variant="text" size="xsmall" color={COLORS.TEXT_TERTIARY_LITE}>
          to
        </Typography>
        <DatePicker
          defaultValue={moment(dateRange.endDate, dateFormat)}
          onChange={handleEndDateChange}
          format={dateFormat}
          value={dateRange.endDate ? moment(dateRange.endDate, dateFormat) : null}
          name="End Date"
          disabledDate={(current) => {
            // Disable dates beyond today
            if (current && current > moment()) {
              return true;
            }

            // If a start date is selected, enforce constraints
            if (dateRange.startDate && moment(dateRange.startDate).isValid()) {
              const start = moment(dateRange.startDate, dateFormat);
              // Disable dates before the start date
              if (current && current < start) {
                return true;
              }
              // Disable dates more than 3 months after the start date
              if (current && current > start.clone().add(3, 'months')) {
                return true;
              }
            }

            return false;
          }}
        />
      </div>
      {dateError &&
        <Typography type="text" size="xsmall" color={COLORS.ERROR_LITE}>
          {dateError}
        </Typography>
      }
    </div>
  )
};

export default DateRange;
